import { moduleProviderFactory } from 'core/providers';
import { ProductOrderingList, ProductOrderingEdit } from 'application/product-ordering/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.product-ordering',
                pattern: '/products-ordering',
                children: [
                    {
                        name: 'master.app.main.product-ordering.list',
                        pattern: '',
                        tabTitle: 'PRODUCT_ORDERING.LIST.TITLE',
                        component: ProductOrderingList,
                        data: {
                            title: 'PRODUCT_ORDERING.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.product-ordering.create',
                        pattern: '/create',
                        tabTitle: 'PRODUCT_ORDERING.CREATE.TITLE',
                        component: ProductOrderingEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PRODUCT_ORDERING.CREATE.TITLE'
                        },
                    }     
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.PRODUCTS_ORDERING',
                        route: 'master.app.main.product-ordering.list',
                        order: 12.1,
                    }                    
                ]
            }
        ]
    });
})();

